import { render, staticRenderFns } from "./ClassCulture2.vue?vue&type=template&id=7729e508&scoped=true&"
import script from "./ClassCulture2.vue?vue&type=script&lang=js&"
export * from "./ClassCulture2.vue?vue&type=script&lang=js&"
import style0 from "./ClassCulture2.vue?vue&type=style&index=0&id=7729e508&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7729e508",
  null
  
)

export default component.exports